import React, { useState, useEffect } from "react";
import { Search, Plus, LogIn, X } from "lucide-react";
import { apiPost } from "../igualdad-api.js";
import { useIgualdad } from "../igualdad-store.jsx";
import { navigate } from "../router.jsx";

/* ============================================================
   Talention — Entrada por empresa
   El consultor elige la empresa que va a auditar y trabaja dentro
   de ella hasta que la cambia. Raiz del contexto de toda la app.
   ============================================================ */

function Empresas() {
  const { session, loadClientes, setClienteById, fireToast } = useIgualdad();
  const [q, setQ] = useState("");
  const [modal, setModal] = useState(false);
  const [nombre, setNombre] = useState("");
  const [cif, setCif] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  // Refresca la lista al entrar (por si se creo una empresa en otra sesion).
  useEffect(() => { loadClientes(); }, []);

  const t = q.trim().toLowerCase();
  const filtradas = !t ? session.clientes
    : session.clientes.filter((c) =>
        String(c.nombre).toLowerCase().includes(t) || String(c.cif || "").toLowerCase().includes(t));

  async function entrar(id) {
    await setClienteById(id);
    navigate("/dashboard");
  }

  async function crear() {
    setSaving(true); setErr(null);
    try {
      const { data } = await apiPost("/clientes", { nombre: nombre.trim(), cif: cif.trim() || null });
      await loadClientes();
      fireToast("Empresa creada.");
      setModal(false); setNombre(""); setCif("");
      await entrar(data.id);
    } catch (e) {
      setErr(e?.errors ? Object.values(e.errors).flat().join(" ") : (e?.message || "No se pudo crear la empresa."));
    } finally { setSaving(false); }
  }

  return (
    <div className="rb-page">
      <div className="rb-pagehead">
        <div>
          <div className="rb-eyebrow">Consultoría</div>
          <h1 className="rb-h1">Empresas</h1>
          <p className="rb-sub">Elige la empresa que vas a auditar o crea una nueva.</p>
        </div>
        <button className="rb-btn rb-btn-primary" onClick={() => setModal(true)}>
          <Plus size={16} /> Nueva empresa
        </button>
      </div>

      <div className="rb-toolbar">
        <div className="rb-search">
          <Search size={15} />
          <input className="rb-inp-font" placeholder="Buscar empresa por nombre o CIF…" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
      </div>

      <div className="rb-grid-cards">
        {filtradas.map((c) => (
          <div key={c.id} className="rb-card rb-empresa-card">
            <div className="rb-empresa-nom">{c.nombre}</div>
            <div className="rb-empresa-cif">{c.cif || "Sin CIF"}</div>
            <button className="rb-btn rb-btn-sm" onClick={() => entrar(c.id)}>
              <LogIn size={14} /> Entrar
            </button>
          </div>
        ))}
        {filtradas.length === 0 ? <div className="rb-empty">No hay empresas que coincidan.</div> : null}
      </div>

      {modal ? (
        <div className="rb-modal-bg" onClick={() => setModal(false)}>
          <div className="rb-modal" onClick={(e) => e.stopPropagation()}>
            <div className="rb-modal-h">
              <span>Nueva empresa</span>
              <button className="rb-icon-btn" onClick={() => setModal(false)}><X size={16} /></button>
            </div>
            <div className="rb-modal-b">
              {err ? <div className="rb-alert-bad">{err}</div> : null}
              <label className="rb-field">
                <span>Nombre</span>
                <input className="rb-inp" value={nombre} onChange={(e) => setNombre(e.target.value)} />
              </label>
              <label className="rb-field">
                <span>CIF</span>
                <input className="rb-inp" value={cif} onChange={(e) => setCif(e.target.value)} />
              </label>
            </div>
            <div className="rb-modal-f">
              <button className="rb-btn" onClick={() => setModal(false)}>Cancelar</button>
              <button className="rb-btn rb-btn-primary" disabled={saving || !nombre.trim()} onClick={crear}>
                {saving ? "Creando…" : "Crear y entrar"}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export { Empresas };
